import React from "react";
import Imggrid from "./imagem_grid/perfil.png";
import Imggrid1 from "./imagem_grid/logo.png";
import "./grid.css";

/**
 * Central de links moderna, sem libs extras.
 * - Acessível (aria-labels, foco visível)
 * - Responsiva (mobile-first)
 * - Sem posicionamento absoluto para os botões
 * - Animações suaves e reduzidas se o usuário prefere menos movimento
 * - Links externos com segurança (rel noopener)
 */

const IconArrow = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M9 18l6-6-6-6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IconGlobe = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="2"/>
    <path d="M3 12h18M12 3c3 3.6 3 14.4 0 18M12 3c-3 3.6-3 14.4 0 18" fill="none" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

const IconLinkedIn = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M4.98 3.5C4.98 4.88 3.86 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1 4.98 2.12 4.98 3.5zM.5 8h4V24h-4V8zm7 0h3.84v2.18h.05C12.17 8.9 13.74 8 15.8 8c4.08 0 4.83 2.69 4.83 6.19V24h-4v-7.49c0-1.79-.03-4.09-2.5-4.09-2.5 0-2.88 1.95-2.88 3.96V24h-4V8z" fill="currentColor"/>
  </svg>
);

const IconMail = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M4 6h16a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z" fill="none" stroke="currentColor" strokeWidth="2"/>
    <path d="M22 8l-10 7L2 8" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const IconInstagram = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <rect x="3" y="3" width="18" height="18" rx="5" ry="5" fill="none" stroke="currentColor" strokeWidth="2"/>
    <circle cx="12" cy="12" r="3.5" fill="none" stroke="currentColor" strokeWidth="2"/>
    <circle cx="17.5" cy="6.5" r="1.2" fill="currentColor"/>
  </svg>
);

function LinkItem({ href, label, icon: Icon, external = true }) {
  return (
    <a
      className="link-item"
      href={href}
      target={external ? "_blank" : undefined}
      rel={external ? "noopener noreferrer" : undefined}
      aria-label={label}
    >
      <span className="link-left">
        <span className="icon"><Icon /></span>
        <span className="link-text">{label}</span>
      </span>
      <span className="icon arrow"><IconArrow /></span>
    </a>
  );
}

export function GridPerfil() {
  const year = new Date().getFullYear();

  return (
    <main className="link-hub">
      <section className="profile-card" aria-labelledby="heading">
        <header className="profile-header">
          <div className="avatar-wrap">
            <img
              className="avatar"
              src={Imggrid}
              alt="Foto de perfil de Patriky Brito"
              width="120"
              height="120"
              loading="eager"
            />
          </div>

          <h1 id="heading" className="name">Patriky Brito</h1>
          <p className="handle" aria-label="Usuário">@patrikyb_dev</p>
        </header>

        <nav className="link-list" aria-label="Links principais">
          <LinkItem
            href="https://portfoliobrito.netlify.app"
            label="Portfólio"
            icon={IconGlobe}
          />
          <LinkItem
            href="https://www.linkedin.com/in/patriky-brito/"
            label="LinkedIn"
            icon={IconLinkedIn}
          />
          <LinkItem
            href="mailto:patrikybrito@gmail.com"
            label="E-mail"
            icon={IconMail}
            external={false}
          />
          <LinkItem
            href="https://www.instagram.com/patrikyb_dev/"
            label="Instagram"
            icon={IconInstagram}
          />
        </nav>

        <footer className="footer">
          <img
            className="logo"
            src={Imggrid1}
            alt="Logomarca pessoal"
            width="72"
            height="72"
            loading="lazy"
          />
          <p className="copyright">© {year} — all rights reserved.</p>
        </footer>
      </section>
    </main>
  );
}

export default GridPerfil;
